import axios from 'axios';
import { GetUserData } from "../../functions/authenticate";
import React, { useEffect, useState } from "react";
import Tabs from "@mui/material/Tabs";

import CircularProgress from '@mui/material/CircularProgress';
import Tab from "@mui/material/Tab";
import {
  Card,
  Backdrop,
  CardContent,
  Divider,
  Grid,
  InputAdornment,
  TextField,
  Typography,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import SearchIcon from "@mui/icons-material/Search";
import SaveIcon from "@mui/icons-material/Save";
import DonutChart from "../../components/donutchart";
import { Link, Navigate, useNavigate } from "react-router-dom";
import CreateCase from "../../components/createCase";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import {toast} from 'react-toastify';
import {addQuickNotes} from '../../functions/apicall';
import CaseStatusLabel from '../../components/CaseStatusLabel';
import { get, lowerCase } from 'lodash';
import QuickNotes from '../../components/QuickNotes';
import HomeCard from '../../components/base/HomeCard';
import { API_URL } from '../../utilities/config';
import Box from '../../components/base/Box';

export default function Main(props) {
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const [data, setData] = useState(null);
  const [cases, setCases] = useState(null);
  const [indexes, setIndexes] = useState(0);
  const [caseLoad, setCaseLoad] = useState(true);
  const [loading, setLoading] = useState(true);
  const [content, setContent] = useState("");
  const MINUTE_MS = 10000;

  const refetchData = (showErrorOnRefresh = true) => {
    // setCases(null);
    // setData(null);
    const userData = JSON.parse(localStorage.getItem('user'));
    const body = {
      user_id: userData.sub
    }
    axios.post(`${API_URL}/fetchLegalDiscoveryDashboard`, body, {})
      .then(res => {
        let apiData = {
          all_legal_discovery_count: res.data.all_legal_discovery_count,
          my_favorites: res.data.my_favorites,
          number: 123,
          recent_cases: []
        }
        for (let r_c of res.data.recent_cases) {
          let new_obj = {};
          new_obj['id'] = r_c['id'];
          new_obj['case_name'] = r_c['case_name'];
          new_obj['abusive word'] = r_c['abusive_words_count'];
          new_obj['total_docs'] = r_c['total_document_count'];
          new_obj['sentiment_score'] = r_c['sentiment_score'];
          new_obj['sentiment_label'] = r_c['sentiment_label'];
          new_obj['status'] = lowerCase(r_c['status']);
          apiData.recent_cases.push(new_obj);
        }
        setData(apiData);
        if (apiData.recent_cases) {
          setCases(apiData.recent_cases);
        }
        // setLoading(false);
      })
      .catch(err => {
        if(showErrorOnRefresh){
          toast.error('Error getting dashboard data');
        }
      })
  }

  useEffect(() => {
    if (data && cases) {
      setLoading(false);
    }
  }, [data, cases]);

  useEffect(() => {
    const interval = setInterval(() => {
      refetchData(false);
    }, MINUTE_MS);

    return () => clearInterval(interval);
  }, [])

  const addNot = async()=>{
    const userData = await JSON.parse(localStorage.getItem('user'));

    let cont = {
      user_id: userData.sub,
      content:content
    }
    let adNotes = await addQuickNotes(cont);
    if(adNotes){
      toast.success("Updated Successfully")
    }
  }


  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user'));
    if (userData) {
      const body = {
        user_id: userData.sub
      }
      axios.post(`${API_URL}/fetchLegalDiscoveryDashboard`, body, {})
        .then(res => {
          let apiData = {
            all_legal_discovery_count: res.data.all_legal_discovery_count,
            my_favorites: res.data.my_favorites,
            number: 123,
            recent_cases: [],
            notes:res.data.notes
          }
          for (let r_c of res.data.recent_cases) {
            let new_obj = {};
            new_obj['id'] = r_c['id'];
            new_obj['case_name'] = r_c['case_name'];
            new_obj['abusive word'] = r_c['abusive_words_count'];
            new_obj['total_docs'] = r_c['total_document_count'];
            new_obj['sentiment_score'] = r_c['sentiment_score'];
            new_obj['sentiment_label'] = r_c['sentiment_label'];
            new_obj['status'] = lowerCase(r_c['status']);
            // new_obj['sentiments_nagative'] = r_c['nagative_sentiment_value'];
            apiData.recent_cases.push(new_obj);
          }
          setData(apiData);
          if (apiData.recent_cases) {
            setCases(apiData.recent_cases);
          }
          if(apiData.notes && apiData.notes.content){
            // alert("yes")
            setContent(apiData.notes.content)
          }
          // setLoading(false);
        })
        .catch(err => {
          toast.error('Error getting dashboard data');
          setLoading(false);
        })
    } 
  }, []);

  const onNextPress = async () => {
    setCaseLoad(false);
    if (indexes < cases.length - 1) {
      await setIndexes(indexes + 1);
    }
    setCaseLoad(true);
  };

  const onPrevPress = async () => {
    setCaseLoad(false);

    if (indexes > 0) {
      await setIndexes(indexes - 1);
    }
    setCaseLoad(true);
    console.log(indexes);
  };

  return (
    <>
      { loading ?
        <Backdrop
          sx={{ color: '#fff', zIndex: '1500' }}
          open={loading}
          // onClick={handleClose}
        >
          <CircularProgress color="inherit" />
        </Backdrop>
      :
        <Grid container spacing={2} className="maindivpage">
          <Grid md={12} sm={12} xs={12} lg={12}>
            <h2 className="pagehead" style={{marginBottom: '5px', marginTop: '20px'}}>Overview</h2>
          </Grid>
          <CreateCase refreshData={refetchData} open={open} setOpen={setOpen} />
          <Grid md={7.7} sm={12} xs={12} lg={7.7}>
            <Grid container>
              <Grid md={4} sm={6} xs={6} lg={4}>
                <Link className="homecrdlnk" to={"/dashboard/detail"}>
                  <HomeCard>
                    <p className="homecrdtitle">
                      All Legal <br />
                      Discoveries
                    </p>
                    <div align="center">
                      <h1 className="homecrdcount">
                        {data && data.all_legal_discovery_count
                          ? data.all_legal_discovery_count
                          : 0}
                      </h1>
                    </div>
                  </HomeCard>
                </Link>
              </Grid>
              <Grid md={4} sm={6} xs={6} lg={4}>
                <Link className="homecrdlnk" to={"/dashboard/detail?favorites=true"}>
                  <HomeCard>
                    <p className="homecrdtitle">
                      My <br />
                      Favorites
                    </p>
                    <div align="center">
                      <h1 className="homecrdcount">
                        {data && data.my_favorites ? data.my_favorites : 0}
                      </h1>
                    </div>
                  </HomeCard>
                </Link>
              </Grid>
              <Grid md={4} sm={6} xs={6} lg={4}>
                <Link
                  onClick={() => {
                    setOpen(true);
                  }}
                  className="homecrdlnk"
                >
                  <HomeCard>
                    <p className="homecrdtitle">
                      Create <br />
                      New
                    </p>
                    <div align="center">
                      <h1 className="homecrdcount">
                        <AddIcon fontSize="40" className="homecrdicn" />
                      </h1>
                    </div>
                  </HomeCard>
                </Link>
              </Grid>
            </Grid>
            {cases && cases.length > 0 && (
              <HomeCard sx={{
                paddingTop: "10px",
                paddingBottom: "50px",
              }}>
                <p>Recent Case</p>
                <Grid container>
                  <Grid md={6} lg={6} sm={6} xs={6}>
                    <Link className='dashboardCaseTitleLink' to={`/case/detail/${cases[indexes].id}`}><h2>{cases[indexes].case_name}</h2></Link>
                  </Grid>
                  <Grid md={6} lg={6} sm={6} xs={6}>
                    <div align="right">
                      <Box
                        component="a"
                        onClick={() => {
                          onPrevPress();
                        }}
                        sx={{ paddingRight: '10px' }}
                      >
                        <ArrowBackIosNewIcon className="casArrIcn" />
                      </Box>
                      <Box
                        component="a"
                        onClick={() => {
                          onNextPress();
                        }}
                        sx={{ paddingLeft: '10px' }}
                      >
                        <ArrowForwardIosIcon className="casArrIcn" />
                      </Box>
                    </div>
                  </Grid>
                </Grid>
                <Divider />
                <Grid container>
                  <Grid md={12} lg={12} sm={12} xs={12}>
                    <h4>Case Analytics</h4>
                  </Grid>
                  <Grid md={8} lg={8} sm={12} xs={12}>
                    {caseLoad ? (
                      <Grid container sx={{ display: 'flex', flexDirection: 'column', gap: '12px', height: '100%', justifyContent: 'center', alignItems: 'center' }}>
                        <CaseStatusLabel status={get(cases[indexes], 'status', null)} sx={{fontSize: 'xx-large', padding: '5px 15px'}} />
                      </Grid>
                    ) : (
                      <></>
                    )}
                  </Grid>
                  <Grid md={4} lg={4} sm={12} xs={12}>
                    <Grid container>
                      <Grid md={12} lg={12} sm={6} xs={6} className="hmchrtinfo">
                        <h1>{cases[indexes][`abusive word`]}</h1>
                        <p>
                          Abusive <br /> Words
                        </p>
                      </Grid>
                      <Grid md={12} lg={12} sm={6} xs={6} className="hmchrtinfo">
                        <h1>{cases[indexes][`total_docs`]}</h1>
                        <p>
                          Total <br /> documents
                        </p>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </HomeCard>
            )}
          </Grid>
          <Grid md={0.3} sm={12} xs={12} lg={0.3}></Grid>
          <Grid md={4} sm={12} xs={12} lg={4}>
            <Grid className="homecrd3">
              <TextField
                onKeyDown={(e) => {
                  if (e.key === 'Enter') {
                    const value = document.getElementById("input-with-icon-textfield").value || ''
                    navigate(`/dashboard/detail?search=${encodeURIComponent(value)}`);
                  }
                }}
                className="homesearch"
                id="input-with-icon-textfield"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                placeholder="Search by case name"
                variant="outlined"
              />
            </Grid>
            <QuickNotes update={addNot} setContent={setContent} content={content} />
          </Grid>
        </Grid>
      }
    </> 
  );
}
